module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/twitter.301a5402.svg";